import * as React from 'react';
import * as Colors from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';
import { Icon } from '../../../interfaces/ICruise';
import * as InclusivesIcons from '../helper/InclusiveIcons';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        margin: '12px 12px 0 12px',
        display: 'flex',
        flexWrap: 'wrap',
    },
    section: {
        marginBottom: '12px',
        padding: '0 3px',
        whiteSpace: 'normal',
        flex: '0 50%',
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        fill: Colors.lightGreen,
        display: 'inline-flex',
    },
    text: {
        display: 'inline',
        fontSize: 13,
        marginLeft: '4px',
        wordWrap: 'break-word',
    },
};

export const getIcons = (icons: Icon[], withText: boolean, customStyle: React.CSSProperties = {}) =>
    icons.map((icon) => {
        const IconComp = InclusivesIcons[icon?.icon];
        if (!IconComp) {
            return null;
        }

        return (
            <div style={{ ...styles.section, ...customStyle }} key={icon.icon}>
                <div style={styles.icon}>
                    <IconComp width={28} height={28} />
                </div>
                {withText && <div style={styles.text}>{__(icon.text, 'dreamlines')}</div>}
            </div>
        );
    });

interface Props {
    icons: Icon[];
}

export function Inclusives(props: Props) {
    const { icons } = props;
    const customStyle = icons.length === 1 ? { justifyContent: 'center' } : {};

    return (
        <div style={{ ...styles.wrapper, ...customStyle }}>
            {getIcons(icons, true, customStyle)}
        </div>
    );
}
